import MenuLeft from '../../components/cabinets/menuleft';
import BottomNavZdo from '../../components/cabinets/BottomNavZdo';

import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { getUserInfo } from '../../services/apiClient';

import { config } from './data/config';

import { getKindergartenInfo } from '../kindergartens/detail/actions';
import { GroupsList } from '../kindergartens/detail/components/KindergartenGroups';
import RequestsQueue from '../kindergartens/detail/components/QueueFull';

import GroupModal from '../kindergartens/detail/components/GroupDetail';
import { emptyData, transformFromServer } from '../kindergartens/detail/components/GroupDetail/data';

import ChildCardModal from '../kindergartens/detail/components/ChildrenCard';
import ZDOPassport from '../kindergartens/detail/components/ZDOPassport';
import ReceptionQueue from './components/ReceptionQueue';
import EmployeesList from '../kindergartens/detail/components/Employee/ EmployeesList';
import DocumentTypesList from '../kindergartens/detail/components/Dictionary/TypeDocuments/DocumentTypesList';
import DocumentsList from '../kindergartens/detail/components/DocumentsList';
import StaffScheduleList from '../kindergartens/detail/components/StaffScheduleList';

import { BDAddInfoKg } from '../kindergartens/detail/components/AddInfo/BDAddInfoKg';
import { PCAddInfoKg } from '../kindergartens/detail/components/AddInfo/PCAddInfoKg';
import ReportsList from '../kindergartens/detail/components/ReportsList/ReportsList';
import ArchiveGroupsTabs from '../kindergartens/detail/components/KindergartenGroups/ArchiveGroupsTabs';
import PositionsList from '../kindergartens/detail/components/Dictionary/TypePositions/PositionsList';
import AcademicYearsList from '../kindergartens/detail/components/Dictionary/AcademicYearsList/AcademicYearsList';
import GroupPlaceTypesList from '../kindergartens/detail/components/Dictionary/GroupPlaceTypes/GroupPlaceTypesList';
import VacancyReport from '../kindergartens/detail/components/VacancyReport/VacancyReport';
import TariffsList from '../kindergartens/detail/components/Dictionary/TarifsList/TarifsList';
import ExitFromEdit from './components/returnToMain/ExitFromEdit';
import { getFreeTabNumber } from './helpers';
import ListChildrenSKG from '../kindergartens/detail/components/ListOfChildrensKG';
import { SchedulerVisits } from './components/ReceptionQueue/components/SchedulerVisits';
import { VisitsListKG } from './components/ReceptionQueue/components/VisitsListKG';
import AcceptChildrenNew from '../kindergartens/detail/components/AcceptChildren/Acceptchildrennew';
import ApplicationModal from '../kindergartens/detail/components/ApplicationCard/ApplicationModal';
import KindergartenAccess from './components/Users/Kindergartenaccess';
import MediaGalleryAdmin from '../kindergartens/detail/components/MediaGallery/MediaGalleryAdmin';
import TeamAdmin from '../kindergartens/detail/components/Team/TeamAdmin';
import NewsAdmin from '../kindergartens/detail/components/News/NewsAdmin';
import KitchenStockManagement from '../kindergartens/detail/components/KitchenStockManagement/KitchenStockManagement';
import MenuDay from '../kindergartens/detail/components/KitchenMenuDay/MenuDay';
import K85Report from '../kindergartens/detail/components/K85Report/K85Report';


const user_role = getUserInfo("role");

const checkModerator = ()=>{
  const role = user_role;
  if(!role) return false;
  return ['admin', 'moderator', 'specialist'].includes(role);
}

const isModerator = checkModerator();


const CabinetPage = () => {

  const userInfo = getUserInfo();

  const getArea = () => userInfo?.privilegedUser?.area || null;
  const getRole = () => {
    const { role, role_main } = userInfo?.privilegedUser || {};
    return config.cabinetMenu[role_main ? [role, role_main].join(':') : role] || null;
  };

  const { menuItems, level2Items, additionalLinks, title, cabinetName, rightPossible, exitFromEdit } = getRole();

  const [activeView,               setPart]                   = useState();
  const [prevPart,                 setPrev]                   = useState();
  const [dataGroupEdit,            setDataGroupEdit]           = useState({});
  const [isEditGroup,              setIsEditGroup]             = useState(false);
  const [showModalEditGroup,       setShowModalEditGroup]      = useState(false);
  const [showModalEditChildrenEdit,setIsModalOpenChildrenEdit] = useState(false);
  const [badges,                   setBadges]                  = useState({});
  const [kindergartenData,         setData]                    = useState({});
  const [isEditGroupMode,          setEditModeGroup]           = useState('view');

  const [kg_id,          setArea]          = useState(getArea());
  const [roleUser,       setRole]          = useState(getRole());
  const [selectedGroup,  setSelectedGroup] = useState(null);
  const [modeAccess,     setModeAccess]    = useState('view');
  const [modeChildEdit,  setModeChildEdit] = useState('onlyView');
  const [tabelNumber,    setTabelNumber]   = useState('');
  const [typeKitchen,    setTypeKitchen]   = useState('standart');
  const [acceptChildren, setAcceptChildren]= useState(null);


  const [isModalApplicationOpen,       setIsModalApplicationOpen] = useState(false);
  
  const [requestSelectedId, setSelectedId]  = useState(null);


  const detailInfo = (id)=>{
    if(!id) return;
    setSelectedId(id);
    setIsModalApplicationOpen(true);
  }


  const getData = async () => {
    setData(await getKindergartenInfo({ id: kg_id }));
  };

  useEffect(() => {
    if (kg_id) getData();
  }, [kg_id]);

  useEffect(() => {
    setModeAccess(rightPossible.isPossibleEditGroup ? 'edit' : 'view');
    setModeChildEdit('viewonly');
  }, [activeView]);


  const onEditGroupArchive = (data) => {
    setDataGroupEdit(transformFromServer(data));
    setEditModeGroup('view');
    setIsEditGroup(data._id);
    setShowModalEditGroup(true);
  };

  const onEditGroup = (id_group) => {
    const data = kindergartenData.groups.find(gr => gr._id === id_group);
    setDataGroupEdit(transformFromServer(data));
    setIsEditGroup(id_group);
    setShowModalEditGroup(true);
    setEditModeGroup('edit');
  };

  const onNewGroup = () => {
    setDataGroupEdit(emptyData({ kg_id, contacts: kindergartenData.contacts }));
    setIsEditGroup(false);
    setShowModalEditGroup(true);
    setEditModeGroup('edit');
  };

  const handleSave = () => {};

  const handleOutModal = (result) => {
    if (result && result === 'need_update') getData();
    setShowModalEditGroup(false);
  };

  const handleActionMenuSelect = (action, child_id, group_id, tabelNumber, typeKitchen) => {
    const isEdit = rightPossible?.isPossibleEditGroup || false;
    const tFL = { 'звичайне': 'Звичайне', 'дієтичне': 'Дієтичне' };

    if (['edit', 'view'].includes(action)) {
      setIsModalOpenChildrenEdit(child_id);
      setTabelNumber(tabelNumber);
      setTypeKitchen(tFL[typeKitchen]);
      setSelectedGroup(group_id);
      setEditModeGroup(isEdit ? 'edit' : 'view');
      setModeChildEdit(action === 'edit' ? 'edit' : 'viewonly');
    }
  };

  const getGroupInfoByNumber = (numberGr) => {

    if (!numberGr || !kindergartenData.groups) return null;
    const group = kindergartenData.groups.find(g => g.number === numberGr);
    if (!group || !group._id) return null;
    const { _id, name, number, periodStartYear } = group;
    return { _id, name, number, periodStartYear };
  };

  const renderChildrenComponent = () => {
    switch (activeView) {
      case 'orders':
        return (
          <RequestsQueue
            kg_id={kindergartenData._id}
            period={2025}
            setAllCount={(count) => setBadges(Object.assign({}, badges, { orders: count }))}
            isHead={true}
            acceptChildren={(idReq) => setAcceptChildren(idReq)}
            isModerator={isModerator}
            detailInfo={detailInfo}
          />
        );
      case 'passport':
        return <ZDOPassport kg_id={kindergartenData._id} />;
      case 'parents_list':
        return <VisitsListKG idKg={kindergartenData._id} />;
      case 'parents_schedule':
        return <SchedulerVisits kgId={kindergartenData._id} onClose={() => {}} />;
      case 'staff':
        return <EmployeesList kindergartenId={kindergartenData._id} />;
      case 'dict_docs':
        return <DocumentTypesList isEditPossible={rightPossible?.dictionaryEdit?.docs} />;
      case 'documents':
        return <DocumentsList kgId={kindergartenData._id} />;
      case 'staff_schedule':
        return (
          <StaffScheduleList
            kindergartenId={kindergartenData._id}
            groupsCount={kindergartenData?.groups?.length || 0}
            workMode={kindergartenData?.workingHours?.type || ''}
            specialization={kindergartenData?.specialization || ''}
          />
        );
      case 'base':
      case 'base_bda':
        return <BDAddInfoKg kgId={kindergartenData._id} />;
      case 'base_pc':
        return <PCAddInfoKg kgId={kindergartenData._id} />;
      case 'zvit':
        return <ReportsList kg_id={kindergartenData._id} />;
      case 'proffessions':
        return <PositionsList isEditPossible={rightPossible?.dictionaryEdit?.positions} />;
      case 'years_dict':
        return <AcademicYearsList isEditPossible={rightPossible?.dictionaryEdit?.years} />;
      case 'groups_archive':
        return (
          <ArchiveGroupsTabs
            kg_id={kindergartenData._id}
            onEditGroup={onEditGroupArchive}
            isKgHead={true}
            onActionSelect={(action, child_id, group_id) =>
              handleActionMenuSelect(action, child_id, group_id)
            }
          />
        );
      case 'dict_places':
        return <GroupPlaceTypesList />;
      case 'vacancy':
        return <VacancyReport />;
      case 'dict_tarifs':
        return <TariffsList />;
      case 'childrens':
        return (
          <ListChildrenSKG
            kindergartenId={kindergartenData._id}
            groups={kindergartenData.groups}
            onActionSelect={(action, child_id, group_id, tabelNumber, typeKitchen) =>
              handleActionMenuSelect(action, child_id, group_id, tabelNumber, typeKitchen)
            }
          />
        );
      case 'users':
        return <KindergartenAccess kindergartenId={kindergartenData._id}/>
      case 'media':
        return <MediaGalleryAdmin
            kgId={kindergartenData._id}
            groups={kindergartenData.groups} // [{ _id, name }]
          />
      case 'teamadmin':
        return <TeamAdmin kgId={kindergartenData._id} />
      case 'newseditor':
        return <NewsAdmin scope="kg" kgId={kindergartenData._id}/>
      case 'kitchenstock':
        return <KitchenStockManagement />
      case 'kitchenmenu':
        return <MenuDay />
      case 'k85':
        return <K85Report kindergartenId={kindergartenData._id} />;

      default:
        return (
          <div className="groups-content">
            <GroupsList
              period={2025}
              groups={kindergartenData.groups}
              id={kindergartenData._id}
              onEditGroup={onEditGroup}
              isKgHead={true}
              onActionSelect={(action, child_id, group_id, tabelNumber, typeKitchen) =>
                handleActionMenuSelect(action, child_id, group_id, tabelNumber, typeKitchen)
              }
              isArchive={false}
              mode={rightPossible?.isPossibleEditGroup ? modeAccess : 'onlyView'}
              onSelectedDate={(date) => {
                const curDate = new Date().toISOString().split('T')[0];
                setModeAccess(new Date(date) < new Date(curDate) ? 'view' : 'edit');
              }}
              onEditChildren={(value) => setModeChildEdit(value)}
              isAdmin={['admin'].includes(userInfo.privilegedUser.role_main)}
            />
          </div>
        );
    }
  };


  return (
    <div className="profile-page">
      <main className="main-content">
        <Container fluid>
          <Row>
            {/* Left Sidebar — ховається на мобільному через CSS в BottomNavZdo.css */}
            <Col md={2} className="sidebar d-none d-md-block">
              <MenuLeft
                badges={badges}
                onMenuItemClick={setPart}
                activeItem={activeView}
                onAddGroup={onNewGroup}
                data={{ menuItems, level2Items, additionalLinks, title, rightPossible }}
                cabinet={{
                  label: cabinetName,
                  number: kindergartenData.number,
                  name: kindergartenData.name,
                  address: kindergartenData.contacts?.address,
                }}
                ExitFromEdit={() =>
                  ExitFromEdit({ privilegedUser: userInfo?.privilegedUser, exitFromEdit })
                }
              />
            </Col>

            {/* Main Content */}
            <Col xs={12} md={10} className="main-content-area">
              <GroupModal
                show={showModalEditGroup}
                groupData={dataGroupEdit}
                isEditing={isEditGroup}
                onHide={handleOutModal}
                kg_id={kg_id}
                group_id={isEditGroup}
                mode={isEditGroupMode}
                isAdmin={['admin'].includes(userInfo.privilegedUser.role_main)}
              />
              {/* Монтуємо картку лише коли вона відкрита і з key=childId, щоб
                  стан (formData/isEditing) однієї дитини ніколи не переходив до іншої. */}
              {showModalEditChildrenEdit && <ChildCardModal
                key={showModalEditChildrenEdit}
                childId={showModalEditChildrenEdit}
                isOpen={showModalEditChildrenEdit ? true : false}
                onClose={() => setIsModalOpenChildrenEdit(false)}
                onSave={handleSave}
                mode={modeChildEdit}
                kg_id={kindergartenData._id}
                gr_id={selectedGroup}
                tabelNumber={tabelNumber}
                typeKitchen={typeKitchen}
                getFreeTab={() => getFreeTabNumber(kindergartenData.groups)}
              />}
              {renderChildrenComponent()}
              <AcceptChildrenNew
                show={!!acceptChildren}
                idreq={acceptChildren}
                onClose={() => setAcceptChildren(null)}
                getGrInfo={getGroupInfoByNumber}
                kgId={kg_id}
              />
              <ApplicationModal
                  isOpen={isModalApplicationOpen && requestSelectedId}
                  onClose={() => { setSelectedId(null) ;setIsModalApplicationOpen(false)}}
                  applicationId={requestSelectedId}
                  userRole={user_role}
              />
            </Col>
          </Row>
        </Container>
      </main>

      {/* Bottom Navigation — видима тільки на мобільному через CSS */}
      <BottomNavZdo
        menuItems={menuItems}
        level2Items={level2Items}
        additionalLinks={additionalLinks}
        activeItem={activeView}
        badges={badges}
        onMenuItemClick={setPart}
        onAddGroup={onNewGroup}
        title={title}
        rightPossible={rightPossible}
      />
    </div>
  );
};

export default CabinetPage;